import type { FunctionComponent, ReactNode } from 'react';

import {
  BreakPoints,
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
  Header,
  Logo,
  Layout as MobileLayout,
} from '@kanda-libs/ks-design-library';

import useHelpModal from 'components/HelpModal/useHelpModal';

interface LayoutProps {
  children: ReactNode;
}

const Layout: FunctionComponent<LayoutProps> = function ({ children }) {
  const { showHelpModal } = useHelpModal();
  return (
    <BreakPoints
      mobile={
        <MobileLayout
          noBorder
          header={
            <Header.Base hideNumber lines help={showHelpModal}>
              <Logo />
            </Header.Base>
          }
          footer={undefined}
        >
          <>{children}</>
        </MobileLayout>
      }
      desktop={
        <DesktopLayoutBoxed help={showHelpModal}>
          <DesktopLayoutBoxedContent>
            <>{children}</>
          </DesktopLayoutBoxedContent>
        </DesktopLayoutBoxed>
      }
    />
  );
};

export default Layout;
